import {LoginCallback} from '@okta/okta-react';
import {Provider} from 'react-redux';
import {Navigate, Route, Routes} from 'react-router-dom';

import SecureRoutes from 'components/base/SecureRoutes';
import {useFeatures} from 'config/features';
import {getRoute} from 'config/navigation';
import configureAppStore from 'configure-app-store';
import Loadable, {Suspense} from 'utils/Loadable';

const AsyncCreateAccount = Loadable({loader: () => import('features/CreateAccount/components')});
const AsyncHomePhotoUpload = Loadable({loader: () => import('components/homePhotoUpload')});
const AsyncExpressIdCards = Loadable({loader: () => import('features/Express/ExpressIDCards/components')});
const AsyncPayAsGuest = Loadable({loader: () => import('features/Express/PayAsGuest/components')});
const AsycFNOLPreLoginPages = Loadable({loader: () => import('components/fnol/prelogin')});
const AsyncClaimsPreloginUploader = Loadable({loader: () => import('components/claims/PreloginUploader')});
const AuthenticatedPages = Loadable({loader: () => import('components/app/AuthenticatedPages')});
const AsyncForcedLogout = Loadable({loader: () => import('shared/Security/components/ForcedLogout')});

export const ReduxPages = () => {
  const features = useFeatures();

  return (
    <Provider store={configureAppStore()}>
      <Suspense>
        <Routes>
          <Route path={`${getRoute('/photo-upload/home')}/*`} element={<AsyncHomePhotoUpload />} />
          <Route path={getRoute('/express-id')} element={<AsyncExpressIdCards />} />
          {(!features.BillingOutageWindow || !features.BillingLifeOutageWindow) && (
            <Route path={`${getRoute('/pay-as-guest')}/*`} element={<AsyncPayAsGuest />} />
          )}
          <Route path={`${getRoute('/create-account')}/*`} element={<AsyncCreateAccount />} />
          <Route
            path={getRoute('/implicit/callback')}
            element={
              <LoginCallback
                errorComponent={({error}) => {
                  if (
                    error.message?.startsWith(
                      'PKCE requires a modern browser with encryption support running in a secure context'
                    )
                  ) {
                    return <Navigate to={getRoute('/login/unsupported-browser')} />;
                  }
                  return <Navigate to={getRoute('/login/system-error')} />;
                }}
              />
            }
          />
          <Route path={`${getRoute('/claims/fnol/prelogin')}/*`} element={<AsycFNOLPreLoginPages />} />
          <Route path={`${getRoute('/claims/prelogin/upload')}/*`} element={<AsyncClaimsPreloginUploader />} />
          <Route path={getRoute('/forced-logout')} element={<AsyncForcedLogout />} />
          <Route element={<SecureRoutes />}>
            <Route path="*" element={<AuthenticatedPages />} />
          </Route>
        </Routes>
      </Suspense>
    </Provider>
  );
};

export default ReduxPages;
